<template>
    <div>
        <bar-chart
            v-if="loaded"
            :data="datasets"
            :options="options"
            :height="height"
        ></bar-chart>
    </div>
</template>


<script>
import BarChart from "./charts/BarChart";

export default {
    components: {
        BarChart
    },
    props: {
        token: {
            type: String,
            required: true
        },
        dateScope: {
            type: Object,
            required: true
        },
        teamId: {
            type: [Number, String],
            required: false
        },
        brokerId: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            settledHistory: [],
            labels: [],
            datasets: [],
            loaded: true,
            height: 110,
            options: {
                scales: {xAxes: [{display: false,}], yAxes: [{display: false, ticks: {beginAtZero: true}}]},
                legend: {display: false},
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 25  //set that fits the best
                    }
                },
                tooltips: {
                    mode: "label",
                    fullWidth: true,
                    titleFontFamily: "Poppins",
                    titleFontSize: 12,
                    titleMarginBottom: 10,
                    bodyFontFamily: "Poppins",
                    bodyFontSize: 12,
                    bodySpacing: 15,
                    cornerRadius: 0,
                    xPadding: 10,
                    yPadding: 10,
                    backgroundColor: 'rgba(8,7,48,0.8)'
                }
            }
        };
    },
    mounted() {
        this.refreshData();
    },
    created() {
        this.$bus.$on("refreshed-data", value => {
            this.refreshData();
        });
    },
    watch: {
        dateScope: {
            handler(newVal, oldVal) {
                this.refreshData();
            },
            deep: true
        },
        teamId() {
            this.refreshData();
        },
        brokerId: {
            handler(newVal, oldVal) {
                this.refreshData();
            },
            deep: true
        }
    },
    methods: {
        refreshData() {
            this.getsettledHistory();
        },
        async getsettledHistory() {
            try {
                let res = await axios.get(`/api/v2/settled-history`, {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    },
                    params: {
                        startDate: this.$moment(this.dateScope.startDate).format('YYYY-MM-DD'),
                        endDate: this.$moment(this.dateScope.endDate).format('YYYY-MM-DD'),
                        teamId: this.teamId,
                        brokerId: this.brokerId
                    }
                });

                this.settledHistory = res.data;
                let labels = Object.values(this.settledHistory.labels);

                this.datasets = {
                    datasets: [{
                        label: 'Settled',
                        backgroundColor: '#3F51B5',
                        data: Object.values(this.settledHistory.values)
                    }],
                    labels: labels
                };

                this.loaded = true;

            } catch (err) {
                console.error(err);
            }
        }
    }
};
</script>
